import { Typography } from '@klarna/bubble-ui';
import { Card } from '@klarna/mp-ui';
import React from 'react';
import styled from 'styled-components';
import TrackableLink from '../../../../../components/TrackableLink';
import PluginLogo from './PluginLogo';
import { getPluginSetupUrl } from './utils/getPluginSetupUrl';
const STYLES_CARD = {
    borderRadius: '16px',
    border: '1px solid #E3E5E9',
    boxShadow: 'none'
};
const LinkStyle = styled.div.withConfig({ displayName: "LinkStyle", componentId: "sc-1b62s9q" }) `
  a { text-decoration: none; }
`;
const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1xknmnd" }) `
  display: flex;
`;
const LogoContainer = styled.div.withConfig({ displayName: "LogoContainer", componentId: "sc-jajw8f" }) `
  margin-right: 20px;
`;
const LabelContainer = styled.div.withConfig({ displayName: "LabelContainer", componentId: "sc-1prj8hb" }) `
  margin-top: 10px;
`;
export default function Plugin({ plugin, category }) {
    return (React.createElement(Card, { style: STYLES_CARD },
        React.createElement(LinkStyle, null,
            React.createElement(TrackableLink, { href: getPluginSetupUrl(plugin.id), viaRouter: true, category: `${category}/${plugin.id}`, underline: false },
                React.createElement(Container, null,
                    React.createElement(LogoContainer, null,
                        React.createElement(PluginLogo, { imageName: plugin.logo.imageName })),
                    React.createElement(LabelContainer, null,
                        React.createElement(Typography, { textToken: 'text-style/text/labels/body/bold' }, plugin.name)))))));
}
